import React from "react";
import { useState, useEffect } from "react";
import { BarChart, IGroupedData } from "../Charts/BarChart";
import { BarChartWithXValuesRotate } from "../Charts/BarChartWithXValuesRotate";
import { PieChart } from "../Charts/PieChart";
import GanttChart from "../Charts/GanttChart";
import DomGanttChart, { Task } from "../Charts/DomGanttChart";
import GanttChartSVGJS from "../Charts/GanttChartSVGJS";
import MyNotifications from "../MyNotifications/MyNotifications";
export function NotificationsScreen() {
  return <MyNotifications ObjectIds={""} ObjectType={1}></MyNotifications>;
}
